<template>
  <div class="rent_shop">
    <img src="./../../assets/img/rent_shop/1.png" alt="">
    <img src="./../../assets/img/rent_shop/2.png" alt="">
    <looknum-box :lookNumData="lookNumData" :bgColor="bgColor"></looknum-box>
    <img src="./../../assets/img/rent_shop/3.png" alt="">
    <img src="./../../assets/img/rent_shop/4.png" alt="">
    <img src="./../../assets/img/rent_shop/5.png" alt="">
    <img src="./../../assets/img/rent_shop/6.png" alt="">
<!--    <img src="./../../assets/img/rent_shop/10.png" alt="">-->
    <img src="./../../assets/img/rent_shop/7.png" alt="">
    <img src="./../../assets/img/rent_shop/8.png" alt="">
    <data-form pageId="2" :bgColor="bgColor" :formCol="formCol"></data-form>
    <img src="./../../assets/img/rent_shop/9.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      lookNumData: [ /* 显示数据 */
        {
          name: '平台储备铺源量已达',
          num: 78892,
          countFun: ''
        },
        {
          name: '过去一周委托找铺客户',
          num: 78892,
          countFun: ''
        }
      ],
      bgColor: '#003a63' /* 猪色值 */,
      formCol: {
        popData: {
          name: '感谢您的报名，客服会尽快与您联系，为您匹配商铺',
          colorOne: 'rgb(2,72,122)',
          colorTwo: 'rgb(0,58,99)'
        }
      }
    }
  },
  mounted () {
    // let shareData = {
    //   title: '想开店，没商铺？现在找商旺宝，7天租到，年前开业赚大钱',	//	标题
    //   link: `${this.$config.webUrl}/#/20191129`,	//	分享的URL，必须和当前打开的网页的URL是一样的
    //   imgUrl: 'https://swb-bucket01.oss-cn-zhangjiakou.aliyuncs.com/swb/prod/leading/marketing/share1.png'//	缩略图地址
    // }
    // this.$util.wxShareFun(shareData)

      wx.ready(function() {
          let shareData = {
              title: '想开店，没商铺？现在找商旺宝，7天租到，年前开业赚大钱',	//	标题
              link: `${this.$config.webUrl}/20191129`,	//	分享的URL，必须和当前打开的网页的URL是一样的
              imgUrl: 'https://swb-bucket01.oss-cn-zhangjiakou.aliyuncs.com/swb/prod/leading/marketing/share1.png'//	缩略图地址
          }
          wx.onMenuShareAppMessage(shareData);
          wx.onMenuShareTimeline(shareData);
      })





      this.$get(this.$api.countNumApi).then((res) => {
      console.log(res)
      res.data.forEach((item) => {
        item.type == 3 ? this.lookNumData[0].num = item.countNumber : ''
        item.type == 4 ? this.lookNumData[1].num = item.countNumber : ''
      })
    })
  },
  methods: {

  }
}
</script>

<style lang="scss">
  .rent_shop {
    background: #fff;

  img {
    width: 750px;
  }
  }
</style>



// WEBPACK FOOTER //
// src/views/rent_shop/index.vue